/* -----------------Globals--------------- */
import { useCallback } from "react";

import { useFeedbackParams } from "@hooks/useFeedbackParams";
/* -----------------Helpers & Hooks--------------- */
import { sendFeedback } from "@memorang/features/src/feedback/helpers";
import { FeedbackDialog } from "@memorang/ui/src/components/FeedbackDialog";
import type { IconType } from "@memorang/ui/src/index";
import { trackCustomEvent } from "analytics";

type FeedbackDialogContainerProps = {
	visible: boolean;
	onDismiss: () => void;
	title?: string;
	subtitle?: string;
	icon?: IconType;
	cta?: string;
	sessionType?: string;
	rating?: string;
	itemId?: string;
	sessionId?: string;
	threadId?: string;
	runId?: string;
	featureName?: string;
	context?: string;
	responseId?: string;
	type?: "Review" | "Content Flagged";
	feedbackReasonList?: {
		title: string;
		description: string;
		icon: IconType;
		value: string;
	}[];
};

export const FeedbackDialogContainer = ({
	visible,
	onDismiss,
	title,
	subtitle,
	icon,
	cta,
	sessionType,
	rating,
	threadId,
	runId,
	itemId,
	sessionId,
	type,
	featureName,
	context,
	responseId,
	feedbackReasonList,
}: FeedbackDialogContainerProps) => {
	const handleTracking = useCallback((event: string) => {
		trackCustomEvent({ eventName: event });
	}, []);

	const feedbackDialogParams = useFeedbackParams({
		type: type ?? "Review",
		sessionType,
		rating,
		threadId,
		runId,
		itemId,
		sessionId,
		featureName,
		context,
		responseId,
	});

	return (
		<FeedbackDialog
			visible={visible}
			onDismiss={onDismiss}
			feedbackDialogParams={feedbackDialogParams}
			sendFeedback={sendFeedback}
			handleTracking={handleTracking}
			title={title}
			subtitle={subtitle}
			icon={icon}
			cta={cta}
			feedbackReasonList={feedbackReasonList}
		/>
	);
};

export default FeedbackDialogContainer;
